import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';

import {useEffect} from 'react';

export function AutoFocusPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(
    function focusEditorOnMount() {
      editor.focus();
    },
    [editor]
  );

  return null;
}
